import z from "zod";
import { TenancySchema } from "./tenancyTypes";

export const RealmSchema = z
  .object({
    id: z.string(),
    createdAt: z.string(),
    lastAccessed: z.string(),
  })
  .extend(TenancySchema.shape);
export type Realm = z.infer<typeof RealmSchema>;
